import { useState, useEffect } from "react";
import image from "../assets/Eximpe-black.svg";

const Navbar = () => {
  const scrollToTop = () => window.scrollTo({ top: 0 });

  const defaultUTM =
  "?utm_source=online&utm_medium=website&utm_campaign=website_lead&utm_term=landing_page";

const [utmParams, setUtmParams] = useState<string>(() => {
  // Try to get from localStorage on initial load (e.g. second visit)
  return localStorage.getItem('utm_params') || defaultUTM;
});

useEffect(() => {
  const queryString = window.location.search;
  if (queryString && queryString.includes('utm_')) {
    localStorage.setItem('utm_params', queryString);
    setUtmParams(queryString); // Triggers rerender
  }
}, []);

const signupLink = `https://app.eximpe.com/auth/sign-up${utmParams}`;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg w-full">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0 transition-transform duration-300 w-[120px]">
            <img src={image} alt="Eximpe Logo" className="w-full h-auto" />
          </div>

          {/* Sign Up Button */}
          <div>
            <a href={signupLink} onClick={scrollToTop}>
              <button className="px-10 hover:cursor-pointer font-bold py-3 bg-[#1a9f86] text-[20px] text-white rounded-lg hover:bg-[#034435] transition">
                Sign Up
              </button>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
